export default "__VITE_ASSET__dddda62e__"